import React from 'react';
import Parse from 'parse';
import { Link } from 'react-router-dom';
import { Create as RecognitionMedia } from '../media/media.container';
import ResourceWorkspace from './ResourceWorkspace';
import { lifeTaggerApi } from '../api/lifetaggerApi';

export default function MediaWorkspace() {
  const [tab, setTab] = React.useState('content');
  const [assets, setAssets] = React.useState([]);
  const [error, setError] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [attempt, setAttempt] = React.useState(0);
  React.useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    new Parse.Query('Asset')
      .equalTo('ownerId', Parse.User.current())
      .descending('createdAt')
      .limit(100)
      .find()
      .then(
        (items) =>
          active &&
          setAssets(items.map((item) => ({ id: item.id, ...item.toJSON() })))
      )
      .catch(() => active && setError('Your media could not be loaded.'))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [attempt]);
  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    setBusy(true);
    setError('');
    try {
      await lifeTaggerApi.uploadAsset(file);
      setAttempt((n) => n + 1);
    } catch (e) {
      setError(e.message || 'Upload failed. Please try again.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="lt-resources">
      <header className="lt-resource-heading">
        <div>
          <span className="lt-eyebrow">IMAGES, VOICES & STORIES</span>
          <h1>Media.</h1>
          <p>What people experience—and what their phone can recognize.</p>
        </div>
      </header>
      <div role="group" aria-label="Media purpose">
        <button
          aria-pressed={tab === 'content'}
          onClick={() => setTab('content')}
        >
          Content media
        </button>{' '}
        <button
          aria-pressed={tab === 'recognition'}
          onClick={() => setTab('recognition')}
        >
          Recognizable media
        </button>
      </div>
      {tab === 'recognition' ? (
        <>
          <h2>Media that reveals a LifeObject</h2>
          <p>
            Register audio or video with ACRCloud so a phone can recognize its
            sound. This is a discovery requirement—not the content someone sees.
            A fingerprint does not enable listening automatically.
          </p>
          <RecognitionMedia />
          <ResourceWorkspace kind="audio" />
        </>
      ) : (
        <>
          <h2>Media people experience</h2>
          <p>
            Images, videos, audio, and documents for your LifeObjects. Uploading
            here does not register an audio fingerprint.
          </p>
          <label>
            Upload a file{' '}
            <input
              type="file"
              disabled={busy}
              onChange={upload}
              accept="image/*,video/*,audio/*,application/pdf"
            />
          </label>
          {busy && <p role="status">Uploading…</p>}
          {loading && <p role="status">Loading media…</p>}
          {error && (
            <p role="alert">
              {error}{' '}
              <button onClick={() => setAttempt((n) => n + 1)}>Retry</button>
            </p>
          )}
          <div className="lt-resource-grid">
            {assets.map((asset) => (
              <article className="lt-resource-card" key={asset.id}>
                <h2>{asset.name}</h2>
                <p>{asset.mimeType}</p>
                <Link
                  to={{
                    pathname: '/objects',
                    search: '?create=1',
                    state: { asset },
                  }}
                >
                  Create LifeObject with this media ↗
                </Link>
              </article>
            ))}
          </div>
          {!loading && !error && !assets.length && (
            <p>No uploaded content media yet.</p>
          )}
          {assets.length >= 100 && <p>Showing your 100 most recent files.</p>}
        </>
      )}
    </section>
  );
}
